<template>
  <Skeleton title :row="6" :loading="!Object.keys(data).length" />
  <section v-for="item in data" :key="item.channel.id" class="home-section">
    <header class="home-section-header">
      <h2>{{item.channel.name}}</h2>
      <router-link :to="`/channel/${item.channel.id}`">更多</router-link>
    </header>
    <section v-if="item.photo" class="home-section-photo">
      <router-link :to="`/article/${item.photo.id}`">
        <img :src="item.photo.img" :alt="item.photo.title">
        <h4>{{ item.photo.title }}</h4>
        <p>{{ item.photo.description }}</p>
      </router-link>
    </section>
    <section class="home-section-list  small-list">
      <ul>
        <li v-for="article in item.list" :key="`article-${article.id}`">
          <router-link :to="`/article/${article.id}`">{{article.title}}</router-link>
        </li>
      </ul>
    </section>
  </section>
</template>
<script>
import { Skeleton } from 'vant'
import 'vant/es/skeleton/style'

export default {
  name: 'mHomeSectionNews',
  components: { Skeleton },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
